module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/store_images/4_5d45bf244c2b1b912b7570ecef04d23f.png";